<template>
  <i-modal class="site-msg-modal"
           width="595"
           title="填写您的信息"
           :value="isShowed"
           @on-visible-change="changeHandler">
    <i-form :model="siteMsg"
            :rules="siteMsgRule"
            ref="siteMsgForm"
            label-position="top">
      <i-form-item label="姓名" prop="from_name">
        <i-input placeholder="您的姓名" v-model="siteMsg.from_name"></i-input>
      </i-form-item>
      <i-form-item label="手机" prop="from_mobile">
        <i-input placeholder="手机号码" class="mobile" v-model="siteMsg.from_mobile">
          <i-select slot="prepend" v-model="siteMsg.from_mobile_code" style="width: 90px">
            <i-option :value="mobileCode.code" v-for="(mobileCode, index) in mobileCodeArr" :label="`+${mobileCode.code}`" :key="index">+{{mobileCode.code}} {{mobileCode.name}}</i-option>
          </i-select>
        </i-input>
      </i-form-item>
      <i-form-item label="其他">
        <i-input type="textarea"
                 :rows="7"
                 placeholder="其他说明（如有）"
                 v-model="siteMsg.from_content"></i-input>
      </i-form-item>
    </i-form>
    <p class="tips">发送后将会把您的手机号码等信息发给对方</p>
    <div slot="footer">
      <div class="save-btn-group">
        <i-button type="text"
                  class="cancel"
                  @click="changeHandler(false)">取消</i-button>
        <i-button class="save-btn"
                  type="primary"
                  size="large"
                  @click="submitSiteMsg">发送信息</i-button>
      </div>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Form, FormItem, Select, Option } from 'iview'
import { deepClone } from '@/common/js/utils'
import * as MSG from 'assets/data/message.js'
import api from 'modules/member/api/index.js'

export default {
  name: 'siteMsgModal',
  data () {
    const mobileValidator = (rule, value, cb) => {
      if (!(/^\d{6,11}$/.test(value))) {
        cb(new Error('手机号格式不正确！'))
      } else {
        cb()
      }
    }
    return {
      siteMsg: {
        from_name: '',
        from_mobile: '',
        from_content: '',
        from_mobile_code: 86
      },
      siteMsgReset: {
        from_name: '',
        from_mobile: '',
        from_content: '',
        from_mobile_code: 86
      },
      siteMsgRule: {
        from_name: [{ required: true, message: '请输入姓名' }],
        from_mobile: [{ required: true, message: '请输入手机号码' }, mobileValidator]
      }
    }
  },
  model: {
    prop: 'isShowed',
    event: 'change-show'
  },
  props: {
    isShowed: {
      type: Boolean,
      default: false
    },
    toObj: {
      type: Object,
      default () {
        return {
          to_type: 100, // 接收主体类型 100=资源主页，200=店铺
          to_id: '',
          to_member_openid: ''
        }
      }
    }
  },
  computed: {
    memberProfile () {
      return this.$store.state.member.memberInfo
    },
    mobileCodeArr () {
      return this.$store.state.mobileCode
    }
  },
  methods: {
    changeHandler (isShowed) {
      this.$emit('change-show', isShowed)
      this.siteMsg = deepClone(this.siteMsgReset)
      this.siteMsg.mobile_code = Number(this.memberProfile.mobile_code)
      this.siteMsg.from_mobile = this.memberProfile.mobile
      this.siteMsg.from_name = this.memberProfile.nickname
      this.$refs['siteMsgForm'].resetFields()
    },
    submitSiteMsg () {
      this.$refs['siteMsgForm'].validate(async (valid) => {
        if (valid) {
          let res = await api.siteMsgAdd({
            ...this.siteMsg,
            ...this.toObj
          })
          if (res.code === 200) {
            this.$store.commit('ADD_MESSAGE', { msg: MSG['GLOBAL_SITE_MSG_ADD_SUCCESS'], type: 'success' })
            this.changeHandler(false)
          }
        }
      })
    }
  },
  components: {
    'i-modal': Modal,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-select': Select,
    'i-option': Option
  }
}
</script>

<style lang="stylus">
.site-msg-modal
  font-family:PingFangSC-Regular;
  .ivu-form-item-label
    font-size: 14px
    padding-bottom: 18px
  .tips
    font-size: 16px
    font-weight: 400
    color: $grey-high1
    line-height: 22px
    padding-left 30px
    background: url('../assets/icon-tips.png') 0 center no-repeat
    background-size: auto 20px
</style>



// WEBPACK FOOTER //
// src/components/SiteMsgModal.vue